import { ModelFactory } from '@shared/factories/model.factory';
import {
  CreateServiceSupportedCountryInput,
  ServiceSupportedCountryType,
  UpdateServiceSupportedCountryInput
} from '@generated/graphql';
import { ServiceSupportedCountry } from '@modules/service/models/service-supported-country.model';
import { cloneDeep } from "lodash-es";
import {
  ServiceSupportedCountryForm
} from "@modules/account-settings/pages/business-profile/components/dialog/service-dialog/service-dialog.component";
import { Service } from "@modules/service/models/service.model";
import { SupportedCountry } from "@modules/supported-country/models/supported-country.model";

export class ServiceSupportedCountryFactory extends ModelFactory<ServiceSupportedCountryType, ServiceSupportedCountry> {
  create (state: ServiceSupportedCountryType): ServiceSupportedCountry {
    return new ServiceSupportedCountry(state);
  }

  convertDayToEstimatedTime (day: string | number) {
    return 'P' + day + 'D'
  }

  createCreateInput (
    service: Service,
    supportedCountry: SupportedCountry,
    form: ServiceSupportedCountryForm
  ): CreateServiceSupportedCountryInput {
    const data = cloneDeep(form.value);

    let {
      estimatedTime,
      serviceFee,
      label,
      officialFee,
      officialFeeTaxIncludable,
      serviceFeeTaxIncludable,
      paymentTypeId,
      scopeOfWork,
      description,
      icon
    } = data;

    estimatedTime = this.convertDayToEstimatedTime(estimatedTime)

    return {
      serviceId: service.id,
      supportedCountryId: supportedCountry.id,
      estimatedTime,
      serviceFee,
      label,
      officialFee,
      officialFeeTaxIncludable,
      serviceFeeTaxIncludable,
      paymentTypeId,
      scopeOfWork,
      description,
      icon
    }
  }

  createUpdateInput (item: ServiceSupportedCountry, form: ServiceSupportedCountryForm): UpdateServiceSupportedCountryInput {
    const data = cloneDeep(form.value);
    const address = cloneDeep(form.controls.address.getRawValue());

    let {
      id,
      estimatedTime,
      serviceFee,
      label,
      officialFee,
      officialFeeTaxIncludable,
      serviceFeeTaxIncludable,
      paymentTypeId,
      scopeOfWork,
      description,
      icon
    } = data;

    estimatedTime = this.convertDayToEstimatedTime(estimatedTime)

    const input: UpdateServiceSupportedCountryInput = {
      id,
      label,
      officialFeeTaxIncludable,
      serviceFeeTaxIncludable,
      estimatedTime,
      serviceFee,
      officialFee,
      scopeOfWork,
      description,
      paymentTypeId,
      icon,
      address,
      // updateServiceData: updateServiceData as UpdateServiceInput,
    }

    if (!item.service?.isRegisteredAddress()) {
      delete input.address
    }

    return input
  }
}

export const serviceSupportedCountryFactory = new ServiceSupportedCountryFactory();
